/**
 * Centralized brand color values for use in JS/TS contexts (Recharts series,
 * chart axes, dynamically-rendered SVGs, etc.). Mirrors the Tailwind config
 * and `src/index.css`. Source of truth: Brand Guidelines p.26.
 */

export const BRAND = {
  humus: '#1B2E1D',
  humusDark: '#101C13',
  oldGrowth: '#4B5E43',
  oldGrowthDark: '#2C4A2F',
  linen: '#EFEADF',
  linenDark: '#E0D8CC',
  brightMoss: '#C5DD85',
  brightMossDark: '#335C2C',
  atmosphere: '#AAD8FA',
  atmosphereDark: '#0E415E',
  freshSalmon: '#E8907A',
  freshSalmonDark: '#8E4432',
} as const;

/**
 * Ordered Recharts series palette per BRAND.md / Section 0.4 of the plan:
 * primaries lead, accents follow. Don't reorder — UIs expect index stability.
 */
export const CHART_SERIES = [
  BRAND.humus,
  BRAND.oldGrowth,
  BRAND.brightMossDark,
  BRAND.atmosphereDark,
  BRAND.freshSalmonDark,
  BRAND.oldGrowthDark,
] as const;

/** Semantic helpers for status / delta visualization. */
export const STATUS = {
  positive: BRAND.brightMossDark,
  negative: BRAND.freshSalmonDark,
  info: BRAND.atmosphereDark,
  neutral: BRAND.oldGrowth,
} as const;

/** Hexagon container path (per Brand Guidelines p.38) for marketing-style
 * empty states / hero icons. ViewBox 0 0 100 100. */
export const HEXAGON_PATH =
  'M50 4 L91.6 27 L91.6 73 L50 96 L8.4 73 L8.4 27 Z';
